import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const StoryPage = lazy(() => import('../pages/story/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const FeaturesPage = lazy(() => import('../pages/features/page'));
const ManualPage = lazy(() => import('../pages/manual/page'));
const SafetyPage = lazy(() => import('../pages/safety/page'));
const ForPlacesPage = lazy(() => import('../pages/for-places/page'));
const ForVolunteersPage = lazy(() => import('../pages/for-volunteers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CommercialPage = lazy(() => import('../pages/commercial/page'));
const MaterialsPage = lazy(() => import('../pages/materials/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const VolunteerRecruitmentPage = lazy(() => import('../pages/news/volunteer-recruitment/page'));
const CrowdfundingPressReleasePage = lazy(() => import('../pages/news/cf-press-release/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/story',
    element: <StoryPage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/features',
    element: <FeaturesPage />,
  },
  {
    path: '/manual',
    element: <ManualPage />,
  },
  {
    path: '/safety',
    element: <SafetyPage />,
  },
  {
    path: '/for-places',
    element: <ForPlacesPage />,
  },
  {
    path: '/for-volunteers',
    element: <ForVolunteersPage />,
  },
  {
    path: '/materials',
    element: <MaterialsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/volunteer-recruitment',
    element: <VolunteerRecruitmentPage />,
  },
  {
    path: '/news/cf-press-release',
    element: <CrowdfundingPressReleasePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/commercial',
    element: <CommercialPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
